import Vue from 'vue';

const eventService = {
  install: function (Vue, options) {
    var eventServiceVue = new Vue({});
    Vue.prototype.$eventService = eventServiceVue;
    Vue.eventService = eventServiceVue;
  }
};

export default eventService;



// WEBPACK FOOTER //
// ./src/services/EventService.js